export default [
  {
    path: '/komads/dashboard',
    name: 'komads-dashboard',
    component: () => import('@/views/pages/komads/dashboard/Index.vue'),
    meta: {
      resource: 'Komads - Dashboard',
      action: 'read',
    },
  },
  {
    path: '/komads/setup-billing',
    name: 'komads-setup-billing',
    component: () => import('@/views/pages/komads/setup-billing/Index.vue'),
    meta: {
      resource: 'Komads - Atur Biaya Berlangganan',
      action: 'manage',
    },
  },
  {
    path: '/komads/whitelist-dashboard',
    name: 'komads-whitelist-dashboard',
    component: () => import('@/views/pages/komads/whitelist-dashboard/List.vue'),
    meta: {
      resource: 'Komads - Klaim Whitelisted',
      action: 'manage',
    },
  },
  {
    path: '/komads/whitelisted-topup',
    name: 'komads-whitelisted-topup',
    component: () => import('@/views/pages/komads/whitelisted-topup/List.vue'),
    meta: {
      resource: 'Komads - Aktivitas Whitelist',
      action: 'manage',
    },
  },
  {
    path: '/komads/setup-whitelisted',
    name: 'komads-setup-whitelisted',
    component: () => import('@/views/pages/komads/setup-whitelisted/Index.vue'),
    meta: {
      resource: 'Komads - Aktivitas Whitelist',
      action: 'manage',
    },
  },
  {
    path: '/komads/data-partner',
    name: 'komads-data-partner',
    component: () => import('@/views/pages/komads/data-partner/List.vue'),
    meta: {
      resource: 'Komads - Data Partner',
      action: 'manage',
    },
  },
  {
    path: '/komads/data-partner/:id',
    name: 'komads-data-partner-detail',
    component: () => import('@/views/pages/komads/data-partner/details/Detail.vue'),
    meta: {
      resource: 'Komads - Aktivitas Whitelist',
      action: 'manage',
    },
  },
  {
    path: '/komads/data-partner/:id/detail',
    name: 'komads-data-partner-detail-platform',
    component: () => import('@/views/pages/komads/data-partner/details/platform/Platform.vue'),
    meta: {
      resource: 'Komads - Aktivitas Whitelist',
      action: 'manage',
    },
  },
  {
    path: '/komads/data-partner/:id/detail',
    name: 'komads-data-partner-detail-platform',
    component: () => import('@/views/pages/komads/data-partner/details/platform/Platform.vue'),
    meta: {
      resource: 'Komads - Data Partner',
      action: 'manage',
    },
  },
  {
    path: '/komads/data-partner/:id/detail/history-subscription',
    name: 'komads-data-partner-detail-history',
    component: () => import('@/views/pages/komads/data-partner/details/platform/HistorySubscription.vue'),
    meta: {
      resource: 'Komads - Data Partner',
      action: 'manage',
    },
  },
  {
    path: '/komads/bm-management',
    name: 'komads-bm-management',
    component: () => import('@/views/pages/komads/business-manager/bm-management/List.vue'),
    meta: {
      resource: 'Komads - Kelola BM',
      action: 'manage',
    },
  },
  {
    path: '/komads/bm-management/:id/detail',
    name: 'komads-bm-management-detail',
    component: () => import('@/views/pages/komads/business-manager/bm-management/details/Detail.vue'),
    meta: {
      resource: 'Komads - Kelola BM',
      action: 'manage',
    },
  },
  {
    path: '/komads/account-issues',
    name: 'komads-account-issues',
    component: () => import('@/views/pages/komads/business-manager/account-issues/List.vue'),
    meta: {
      resource: 'Komads - Kelola BM',
      action: 'manage',
    },
  },
  {
    path: '/komads-dashboard/topup-history:account-type',
    name: 'topup-history-komads',
    component: () => import('@/views/pages/komads/dashboard/topup-history/Index.vue'),
    meta: {
      resource: 'Komads - Dashboard',
      navActiveLink: 'Komads-dashboard',
      action: 'read',
    },
  },
]
